export default __webpack_public_path__ + "static/media/Pix-icon-branco.1390f3a6.svg";